export const COLUMNS = [
  { id: "pendiente_revision", label: "Pendiente de Revisión", accent: "#a1a1aa" },
  { id: "en_diagnostico", label: "En Diagnóstico", accent: "#38bdf8" },
  { id: "en_reparacion", label: "En Reparación", accent: "#f59e0b" },
  { id: "listo_entregar", label: "Listo para Entregar", accent: "#22c55e" },
];

const strip = (s) =>
  String(s || "").toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");

export const DELIVERED = "entregado";

export const normalizeEstado = (v) => {
  const s = strip(v);
  if (s.startsWith("entregad")) return DELIVERED;
  if (s.includes("diagn")) return "en_diagnostico";
  if (s.includes("repar")) return "en_reparacion";
  if (s.includes("list") || s.includes("entreg")) return "listo_entregar";
  return "pendiente_revision";
};

export const isPagado = (v) => v === true || strip(v).startsWith("pagad");

export const eur = (n) =>
  new Intl.NumberFormat("es-ES", { style: "currency", currency: "EUR" }).format(Number(n) || 0);

export const shortId = (id) => String(id || "").slice(0, 6).toUpperCase();

export const whatsappUrl = (o, taller) => {
  const tel = String(o.telefono || "").replace(/\D+/g, "");
  if (!tel) return "";
  const label = COLUMNS.find((c) => c.id === o.estado)?.label || "";
  const lines = [
    `Hola${o.cliente ? ` ${o.cliente}` : ""}, le escribimos de ${taller}.`,
    `Su vehículo ${o.modelo || ""} (${o.matricula}) está ahora en estado: *${label}*.`,
  ];
  if (o.estado === "listo_entregar") lines.push("Ya puede pasar a recogerlo.");
  if (!o.pagado && o.importe) lines.push(`Importe: ${eur(o.importe)}.`);
  lines.push("Gracias por su confianza.");
  return `https://wa.me/${tel}?text=${encodeURIComponent(lines.join("\n"))}`;
};

export const toOrder = (row) => {
  const v = row.vehiculos || {};
  const c = v.clientes || {};
  return {
    id: row.id,
    createdAt: row.created_at,
    servicio: row.servicio || "",
    estado: normalizeEstado(row.estado),
    pagado: isPagado(row.estado_pago),
    urgente: row.prioritaria === true,
    importe: Number(row.importe_estimado) || 0,
    vehiculoId: row.vehiculo_id,
    matricula: v.matricula || "",
    modelo: v.marca_modelo || "",
    clienteId: v.cliente_id || c.id,
    cliente: c.nombre || "",
    telefono: v.Telefono || c.telefono || "",
    email: c.email || "",
  };
};
